(function () {
    define('orb/fig', ['orb/stubFig'], function(stubFig) {
        /**
         * Fig module (async)
         * @module orb/fig
         */
        'use strict';
        /// Friendly functions only available to people using async patterns.
        // Ensures we find and fix all integrations when country data is set.
        var fig = {
            load: function(success) {
                // Do not break if client calls this async fig as a function
                var orbFig = function (param) {
                    return stubFig(param);
                };
                // Note that we *do not* extend the global window.orb.fig here
                // If you want these functions, you must require then use the load function
                orbFig.geo = {
                    isUK: function () {
                        return stubFig("uk");
                    }
                };

                orbFig.isCached = function() { return false;}
                orbFig.isOverridden = function() { return false;}

                return success(orbFig);
            }
        };

        return fig;
    });
})();
